import { useFetchQuery } from "common/queries/hooks";

import { PrescriptionList, PrescriptionsSearch } from "../types";
import { keys, urls } from "./constants";

const noop = () => undefined;

export const usePrescriptionsQuery = (
  search: PrescriptionsSearch = {},
  { onError = noop, enabled = true }: { onError?: () => void; enabled?: boolean } = {},
) => {
  return useFetchQuery<PrescriptionList[], PrescriptionsSearch>(keys.prescriptionList(search), {
    fetch: { url: urls.prescriptions(), body: search },
    config: {
      keepPreviousData: true,
      onError,
      enabled,
    },
  });
};
